import { Select } from "antd";
import React, { memo, useCallback, useState } from "react";

const { Option } = Select;

const CONTRACT_TYPE = [
  { id: 1, code: "all", name: "Tất cả" },
  { id: 2, code: 1, name: "Có lái" },
  { id: 3, code: 2, name: "Không lái" },
];

const LoaiHopDong = ({ setFieldsValue, name, value }) => {
  const onChange = useCallback(
    (valueChange) => {
      !!setFieldsValue && setFieldsValue({ [name]: { id: valueChange.value } });
    },
    [setFieldsValue]
  );

  return (
    <Select
      showArrow
      placeholder="Loại hợp đồng"
      labelInValue
      filterOption={false}
      onChange={onChange}
    >
      {CONTRACT_TYPE.map((item, index) => (
        <Option key={index} value={item.code}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default memo(LoaiHopDong);
